import * as z from "zod/mini";

export const connectSearchSchema = z.object({
  ordering: z.optional(z.enum(["completion_rate", "rating", "gigs_worked"])),

  is_verified: z.optional(z.boolean()),
  has_worked_together: z.optional(z.boolean()),
  is_new_pro: z.optional(z.boolean()),

  rating_gte: z.optional(z.number()),
  certifications: z.optional(z.array(z.number())),
  pro_certifications: z.optional(z.array(z.string())),
  previous_positions: z.optional(z.array(z.number())),
  badge_types: z.optional(z.array(z.string())),

  pro_fullname: z.optional(z.string()),
  skill_group: z.optional(z.string()),
});

export type ConnectSearchParams = z.infer<typeof connectSearchSchema>;
